// =============
// Users Module
// =============

import axios from '@/axios';

export default
{
    namespaced: true,


    // ------------------------------------------------------------ STATE

    state()
    {
        return {
            entityUsers: [],
        };
    },


    // ------------------------------------------------------------ GETTERS

    getters:
    {
        getById: state => id =>
        {
            return state.entityUsers.find(user => user.id == parseInt(id));
        },
    },

    // ------------------------------------------------------------ MUTATIONS

    mutations:
    {
        setEntityUser(state, entityUsers)
        {
            state.entityUsers = entityUsers;
        },

        addUser(state, user)
        {
            state.entityUsers.push(user);
        },

        updateUser(state, user)
        {
            const index = state.entityUsers.findIndex(u => u.id === user.id);

            if(index !== -1)
            {
                state.entityUsers[index] = user;
            }
        },
    },

    // ------------------------------------------------------------ ACTIONS

    actions:
    {
        fetchEntityUsers({ commit, rootState })
        {
            const url = '/api/user/entity/:eid'
                .replace(':eid', rootState.account.cEntity.id);

            return axios.get(url)
                .then(response =>
                {
                    commit('setEntityUser', response.data);

                    return response;
                });
        },

        create({ commit, rootState }, { user, options })
        {
            const url = '/api/user/entity/:eid'
                .replace(':eid', rootState.account.cEntity.id);

            const data = {
                user:    user,
                options: options,
            };

            return axios.post(url, data)
                .then(response =>
                {
                    commit('addUser', response.data);

                    return response;
                });
        },

        update({ commit, rootState }, { user, options })
        {
            const url = '/api/user/:user_id/entity/:eid'
                .replace(':eid', rootState.account.cEntity.id)
                .replace(':user_id', user.id);

            const data = {
                user:    user,
                options: options,
            };

            return axios.put(url, data)
                .then(response =>
                {
                    commit('updateUser', response.data);

                    return response;
                });
        },
    },
};
